import React from "react";


const PricingSection = () => {
  return (
    <>
      <style>{`
        .pricing-section {
          background: #DCF6C6; /* section bg */
          padding: 100px 20px;
          text-align: center;
        }

        .pricing-container {
          max-width: 1100px;
          margin: auto;
        }

        .pricing-container h2 {
          font-size: 36px;
          color: #1e2d23;
          margin-bottom: 15px;
        }

        .pricing-container p {
          color: #4b5e52;
          margin-bottom: 60px;
        }

        /* GRID */
        .pricing-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }

        /* ✅ CARD BG FIXED */
        .card {
          background: #EFFFE1; /* card bg different */
          padding: 35px;
          border-radius: 20px;
          text-align: left;

          border: 2px solid #97E074;
          transition: 0.3s;
        }

        .card:hover {
          transform: translateY(-6px);
        }

        /* CENTER CARD */
        .highlight {
          border: 2px solid #97E074;
          position: relative;
        }

        .badge {
          position: absolute;
          top: -15px;
          left: 50%;
          transform: translateX(-50%);
          background: #97E074;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
        }

        .card h3 {
          margin-bottom: 10px;
          color: #1e2d23;
        }

        .price {
          font-size: 26px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .desc {
          font-size: 14px;
          color: #4b5e52;
          margin-bottom: 20px;
        }

        .btn {
          width: 100%;
          padding: 12px;
          border-radius: 999px;
          border: none;
          background: #97E074;
          cursor: pointer;
          font-weight: 500;
          margin-bottom: 20px;
        }

        .btn:hover {
          background: #7ED957;
        }

        hr {
          border: none;
          border-top: 1px solid rgba(0,0,0,0.1);
          margin: 20px 0;
        }

        .features {
          list-style: none;
          padding: 0;
        }

        .features li {
          margin-bottom: 10px;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .check {
          color: #97E074;
          font-weight: bold;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .pricing-grid {
            grid-template-columns: 1fr;
          }

          .pricing-container h2 {
            font-size: 28px;
          }
        }
      `}</style>

      <section className="pricing-section">
        <div className="pricing-container">

          <h2>Proactive Support Packages</h2>
          <p>
            Choose the right plan for your business compliance,
            tax filing, and financial management needs.
          </p>

          <div className="pricing-grid">

            {/* BASIC */}
            <div className="card">
              <h3>Basic</h3>
              <div className="price">₹1,000 – ₹3,000</div>
              <div className="desc">
                Ideal for individuals and small businesses starting out.
              </div>

              <button className="btn">Book Plan ↗</button>
              <hr />

              <ul className="features">
                <li><span className="check">✔</span> Basic ITR Filing</li>
                <li><span className="check">✔</span> GST Basic Returns</li>
                <li><span className="check">✔</span> TDS Quarterly Filing</li>
              </ul>
            </div>

            {/* STANDARD */}
            <div className="card highlight">
              <div className="badge">Best Value</div>

              <h3>Standard</h3>
              <div className="price">₹3,000 – ₹7,000</div>
              <div className="desc">
                Perfect for growing businesses needing compliance support.
              </div>

              <button className="btn">Book Plan ↗</button>
              <hr />

              <ul className="features">
                <li><span className="check">✔</span> All Basic Services</li>
                <li><span className="check">✔</span> GST Monthly Filing</li>
                <li><span className="check">✔</span> Bookkeeping</li>
                <li><span className="check">✔</span> Tax Planning Support</li>
              </ul>
            </div>

            {/* PREMIUM */}
            <div className="card">
              <h3>Premium</h3>
              <div className="price">₹8,000 – ₹20,000+</div>
              <div className="desc">
                Full-service accounting and compliance for businesses.
              </div>

              <button className="btn">Book Plan ↗</button>
              <hr />

              <ul className="features">
                <li><span className="check">✔</span> All Standard Services</li>
                <li><span className="check">✔</span> Advanced Tax Planning</li>
                <li><span className="check">✔</span> Payroll Management</li>
                <li><span className="check">✔</span> Financial Reporting</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default PricingSection;